import dayjs from "dayjs";
import customParseFormat from 'dayjs/plugin/customParseFormat';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import isBetween from 'dayjs/plugin/isBetween';
import { AppealCategory, County } from '../../../commontypes/types';

dayjs.extend(customParseFormat);
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("America/New_York");
dayjs.extend(isBetween);

export const getActiveAppealYear = (county: County, appealCategory: AppealCategory): number => {
  const now = new Date();
  const currentYear = now.getFullYear();

  if (county.key === '03') {
    if (appealCategory === AppealCategory.ADD_OMIT) {
      if (now.getMonth() < 9) {
        return currentYear - 1;
      } else {
        return currentYear;
      }
    } else {
      if (now.getMonth() > 10) {
        return currentYear + 1;
      } else {
        return currentYear;
      }
    }
  }

  //   //TODO fix this to be April 1 if not a weekend
  //   if ((now.getMonth() === 3 && now.getDate() > 3) || now.getMonth() > 3) {
  //     return currentYear + 1;
  //   }
  //   return currentYear;
  // } else {
  //   if (appealCategory === AppealCategory.ADD_OMIT) {
  //     if (now.getMonth() < 9) {
  //       return currentYear - 1;
  //     } else {
  //       return currentYear;
  //     }
  //   }
  //   if (now.getMonth() < 1) {
  //     return currentYear - 1;
  //   }
  //
  // }

  return currentYear;
};